import { render, staticRenderFns } from "./support-article.vue?vue&type=template&id=5c156fe4&"
import script from "./support-article.vue?vue&type=script&lang=js&"
export * from "./support-article.vue?vue&type=script&lang=js&"
import style0 from "./support-article.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ExpandButton: require('/opt/build/repo/storefront/components/legacy/global/expand-button.vue').default,Slider: require('/opt/build/repo/storefront/components/legacy/global/slider.vue').default,SupportArticleProductLinks: require('/opt/build/repo/storefront/components/legacy/support/support-article-product-links.vue').default,SgLink: require('/opt/build/repo/storefront/components/legacy/global/sg-link.vue').default})
